// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2qzvY","content":"Consent_content__2sUxM","footer":"Consent_footer__20bpp"};